import { render } from "./CustomerInformation.vue?vue&type=template&id=46d4eb79"
import script from "./CustomerInformation.vue?vue&type=script&lang=js"
export * from "./CustomerInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__